import { useRef, useState } from 'react'
import {
  Alert,
  Box,
  Button,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import {
  setCnAutomationAuthenticated,
  validateCnAutomationLogin,
} from './cn-automation-auth'

type Props = {
  onSuccess: () => void
}

const CnAutomationLoginPage = ({ onSuccess }: Props) => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const submittingRef = useRef(false)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (submittingRef.current) return
    submittingRef.current = true
    setError('')
    setSubmitting(true)

    if (validateCnAutomationLogin(username.trim(), password)) {
      setCnAutomationAuthenticated()
      onSuccess()
      return
    }

    setError('Invalid username or password.')
    submittingRef.current = false
    setSubmitting(false)
  }

  return (
    <Box
      component="main"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#8a8a8a',
        px: 2,
      }}
    >
      <Paper
        component="form"
        onSubmit={handleSubmit}
        elevation={3}
        sx={{
          width: '100%',
          maxWidth: 400,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Stack spacing={2.5}>
          <Typography variant="h5" align="center" fontWeight={600} color="text.secondary">
            CN automation
          </Typography>
          <Typography variant="body2" align="center" color="text.secondary">
            Sign in to continue
          </Typography>

          {error ? <Alert severity="error">{error}</Alert> : null}

          <TextField
            label="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            required
            fullWidth
            autoFocus
          />
          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
            fullWidth
          />
          <Button type="submit" variant="contained" size="large" disabled={submitting} fullWidth>
            Sign in
          </Button>
        </Stack>
      </Paper>
    </Box>
  )
}

export default CnAutomationLoginPage
